import { render } from "./OpcoesAvancadas.vue?vue&type=template&id=ba982f86&scoped=true&ts=true"
import script from "./OpcoesAvancadas.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpcoesAvancadas.vue?vue&type=script&setup=true&lang=ts"

import "./OpcoesAvancadas.vue?vue&type=style&index=0&id=ba982f86&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba982f86"],['__file',"src/typescript/modulos/governanca/AssistentePontotel/apresentacao/acoplamento/OpcoesAvancadas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba982f86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba982f86', __exports__)) {
    api.reload('ba982f86', __exports__)
  }
  
  module.hot.accept("./OpcoesAvancadas.vue?vue&type=template&id=ba982f86&scoped=true&ts=true", () => {
    api.rerender('ba982f86', render)
  })

}


export default __exports__